"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("@mdi/react"));
const react_2 = __importStar(require("react"));
const js_1 = require("@mdi/js");
const react_3 = require("react");
function AccordionText({ text, lines }) {
    const [expanded, setExpanded] = react_2.useState(false);
    const textRef = react_2.useRef(null);
    const chevronRef = react_2.useRef(null);
    const expandText = () => {
        var _a;
        (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.classList.toggle("accordion-text-expanded");
        setExpanded(!expanded);
    };
    react_3.useEffect(() => {
        const resize = () => {
            var _a, _b, _c;
            if (textRef.current) {
                const fits = ((_a = textRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
                if (24 * lines >= fits)
                    (_b = chevronRef.current) === null || _b === void 0 ? void 0 : _b.classList.add("is-hidden");
                else
                    (_c = chevronRef.current) === null || _c === void 0 ? void 0 : _c.classList.remove("is-hidden");
            }
        };
        resize();
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
        };
    }, [lines]);
    return (react_2.default.createElement("div", { className: "accordion-text is-relative" },
        react_2.default.createElement("p", { className: "is-relative accordion-text-content has-text-black100", ref: textRef }, text),
        react_2.default.createElement("figure", { ref: chevronRef, className: "image is-32x32 accordion-text-chevron is-clickable", onClick: expandText },
            react_2.default.createElement(react_1.default, { path: expanded ? js_1.mdiChevronUp : js_1.mdiChevronDown }))));
}
exports.default = AccordionText;
//# sourceMappingURL=AccordionText.js.map